export const state = {
  viewType: '',
  showLoading: false
}

export const mutations = {
  changeView (state, type) {
    state.viewType = type
  },
  validateLoading (state, value) {
    state.showLoading = value
  }
}
